import { Component } from '@angular/core';

@Component({
	selector: 'ahp-spinner',
	template: `
		<div
			class="ahp-spinner"
			aria-live="polite"
			role="status"
			[attr.aria-label]="'common.loadinglabel' | locale"
		></div>
	`,
	styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {}
